import React, { useContext } from 'react'
import { ColumnInput, ColumnLabel, ColumnsContainer, MinAndMaxContainer } from './style'
import { useOutletContext } from 'react-router-dom'
import { CertificateOutletType } from '../..'
import { FeedbackContext } from '../../../../../contexts/FeedbackContext'

export const isMinGreaterThanMax = (minVal: any, maxVal: any): boolean => {
  if (minVal === null || minVal === undefined || minVal === '' || maxVal === null || maxVal === undefined || maxVal === '') {
    return false
  }
  const minNum = Number(String(minVal).replace(',', '.'))
  const maxNum = Number(String(maxVal).replace(',', '.'))
  if (isNaN(minNum) || isNaN(maxNum)) return false
  return minNum > maxNum
}

const StructureColumns:React.FC<{structureIndex:number}> = ({structureIndex}) => {
  const { param, setParam } = useOutletContext<CertificateOutletType>()
  const { setFeedback } = useContext(FeedbackContext)
  
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>, columnIndex: number, minOrMax: 'min' | 'max') => {
    setParam(prev => ({
      ...prev,
      structures: prev.structures.map((structure, sIndex) => (
        sIndex === structureIndex 
        ? { ...structure, columns: structure.columns.map((column, cIndex) => (
          cIndex === columnIndex
          ? {...column, [minOrMax]: e.target.value}
          : column
        ))} 
        : structure
      ))
    }))
  }

  const handleBlur = (columnIndex: number) => {
    const column = param.structures[structureIndex]?.columns[columnIndex]
    if (column && isMinGreaterThanMax(column.min, column.max)) {
      setFeedback({
        isOpen: true,
        message: `O valor mínimo (${column.min}) não pode ser maior que o valor máximo (${column.max}) na coluna "${column.name}".`,
        statusOk: false,
      })
    }
  }
  
  return (
    <ColumnsContainer quantityGrid={param.structures[structureIndex].columns.length}>
      {param.structures[structureIndex].columns.map((column, index) => 
        <ColumnLabel 
          isItLast={index === param.structures[structureIndex].columns.length - 1}
          key={index}
        > {column.name} {column.unitUsed?.name ? `(${column.unitUsed?.name})` : ''}</ColumnLabel>
      )}
      {param.structures[structureIndex].columns.map((column, index) => {
        const hasError = isMinGreaterThanMax(column.min, column.max)
        const errorTitle = hasError ? 'O valor mínimo não pode ser maior que o valor máximo' : undefined

        return (
          <MinAndMaxContainer key={index}>
            <ColumnInput
              hasError={hasError}
              title={errorTitle}
              placeholder='min'
              position={index === 0 ? 'first' : undefined}
              value={column.min || ''}
              onChange={e => handleChange(e, index, 'min')}
              onBlur={() => handleBlur(index)}
            />
            <ColumnInput
              hasError={hasError}
              title={errorTitle}
              placeholder='max'
              position={index === param.structures[structureIndex].columns.length - 1 ? 'last' : undefined}
              value={column.max || ''}
              onChange={e => handleChange(e, index, 'max')}
              onBlur={() => handleBlur(index)}
            />
          </MinAndMaxContainer>
        )
      })}
    </ColumnsContainer>
  )
}

export default StructureColumns